import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtService } from '../services';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {

  constructor(private jwtService: JwtService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const apiUrl = environment.apiUrl.replace('/v1', '');
    if(req.url.includes(apiUrl) && !req.url.includes('operator/productOffer')) {
      const token = this.jwtService.getTocken();
      if(!!token) {
        if(!req.url.includes(environment.apiUrl.replace('/v1', ''))) return next.handle(req);
        return next.handle(this.jwtService.addTokenToReq(req, token.toString()));
      }
    }
    return next.handle(req);
  }
}
